import data from './animation/world-map-data'
import lottie from 'lottie-web'

export default class WorldMap {
  constructor($el) {
    this.$el = $el;

    this.$animationContainer = this.$el.querySelector('.animation-container')
    this.$animationTrigger = this.$el.querySelector('.animation-trigger')

    this.$player = this.getAnimationPlayer();

    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          this.$player.playSegments([0, 350], true)
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 1
    })

    observer.observe(this.$animationTrigger)
  }

  getAnimationPlayer(){
    const animData = {
      container: this.$animationContainer,
      renderer: 'svg',
      autoplay: false,
      loop: false,
      animationData: data
    }

    return lottie.loadAnimation(animData)
  }
}